import { select } from 'd3';
import { Entidad } from "../../../data/Entidad";
import { _LOCALDATA_GetGruposEnEscuela, _SvEscuelaGoogleGetDirectionInformation } from "../../../data/modulo/Escuela";
import { DateV2 } from "../../../util/DateV2";
import _L from "../../../util/Labels";
import { CheckBox } from "../../controlD3/CheckBox";
import { Fields, FormGenerator, IControlCreated, IField } from "../../controlD3/Formulario";
import { InputFileControl } from "../../controlD3/InputFileControlV2";
import { NotificacionV2 } from "../../controlD3/NotificacionV2";
import { UIUtilLang } from "../../util/Language";
import { UIUtilTime } from "../../util/Time";
import { UIUtilGeneral } from "../../util/Util";
import { UIUtilViewData } from "../../util/ViewData";
import { UIUtilViewGrupos } from "../Grupos";

type IEscuela = Entidad.IEscuela;
import CAccionPermiso = Entidad.CAccionPermiso;

export interface IEscuelaForm extends Partial<Omit<IEscuela, keyof Pick<IEscuela, "EnUso" | "Modificacion">>> {
    NumInterior?: string;
    Calle?: string;
    NumExterior?: string;
    CodigoPostal?: string;
    Ciudad?: string;
    Estado?: string;
    Pais?: string;
    LatLong?: string;

    DiasOperacion?: number[];

    IsChangedLogo?: boolean;
    IsChangedLatLong?: boolean;
}

export enum CEscuelaFormModel {
    Logo = "Logo",
    Nombre = "Nombre",
    Tamanio = "Tamanio",
    Telefono = "Telefono",
    Correo = "Correo",

    Direccion = "Direccion", // Mapa
    Calle = "Calle",
    NumeroInterior = "NumInterior",
    NumeroExterior = "NumExterior",
    CodigoPostal = "CodigoPostal",
    Ciudad = "Ciudad",
    Estado = "Estado",
    Pais = "Pais",

    Entrada = "Entrada",
    Salida = "Salida",
    DiasOperacion = "DiasOperacion",
    // TipoLicencia = "TipoLicencia"
}


function EscuelaForm_GetSchema(form: FormGenerator<IEscuelaForm>): IField<IEscuelaForm>[] {
    const dataTamanioEsc: UIUtilViewData.IBaseData[] = [
        { Id: 20, Name: "1 - 20" },
        { Id: 50, Name: "21 - 50" },
        { Id: 100, Name: "51 - 100" },
        { Id: 300, Name: "101 - 300" },
        { Id: 500, Name: "301 - 500" },
        { Id: 501, Name: "> 500" }
    ]

    return [
        {
            type: Fields.fotoV2,
            fotoV2Attrs: {
                RowClase: "alinear_foto",
                // DefaultBackgroundImage: Utils.CIconResource.User,
                TypeValue: "File",
                AspectRatio: "contain",
                ControlForm: InputFileControl.ControlForm.Semicuadrado,
                OnChange: (isImage, isFromInput) => {
                    if (isImage && isFromInput) {
                        form._DataOrigin.IsChangedLogo = true;
                    }
                }
            },
            model: CEscuelaFormModel.Logo
        },
        {
            type: Fields.input,
            inputAttr: { type: "text", inputProperties: { required: true } },
            labelAttr: { text: "frm1_name" },
            model: CEscuelaFormModel.Nombre
        },
        {
            type: Fields.selectMaterial,
            labelAttr: { text: "frm1_schoolsize" },
            selectMaterialAttr: { valueMember: "Id", displayMember: "Name", },
            values: dataTamanioEsc,
            model: CEscuelaFormModel.Tamanio
        },
        {
            type: Fields.input,
            inputAttr: { type: "phone2_10A", inputProperties: { required: true } },
            labelAttr: { text: "frm1_telefono" },
            model: CEscuelaFormModel.Telefono
        },
        {
            type: Fields.input,
            inputAttr: { type: "email", inputProperties: { required: true } },
            labelAttr: { text: "frm1_email" },
            model: CEscuelaFormModel.Correo
        },
        // Dirección **********
        {
            type: Fields.input,
            inputAttr: { type: "text", disabled: false, inputProperties: { required: true } },
            labelAttr: { text: "frm1_calle" },
            model: CEscuelaFormModel.Calle
        },
        {
            type: Fields.input,
            inputAttr: { type: "text", disabled: false, inputProperties: { required: false } },
            labelAttr: { text: "frm1_numinter" },
            model: CEscuelaFormModel.NumeroInterior
        },
        {
            type: Fields.input,
            inputAttr: { type: "text", disabled: false, inputProperties: { required: true } },
            labelAttr: { text: "frm1_numext" },
            model: CEscuelaFormModel.NumeroExterior
        },
        {
            type: Fields.input,
            inputAttr: { type: "text", disabled: false, inputProperties: { required: true } },
            labelAttr: { text: "frm1_cp" },
            model: CEscuelaFormModel.CodigoPostal
        },
        {
            type: Fields.input,
            inputAttr: { type: "text", disabled: false, inputProperties: { required: true } },
            labelAttr: { text: "frm1_city" },
            model: CEscuelaFormModel.Ciudad
        },
        {
            type: Fields.input,
            inputAttr: { type: "text", disabled: false, inputProperties: { required: true } },
            labelAttr: { text: "frm1_edo" },
            model: CEscuelaFormModel.Estado
        },
        {
            type: Fields.input,
            inputAttr: { type: "text", disabled: false, inputProperties: { required: true } },
            labelAttr: { text: "frm1_pais", },
            model: CEscuelaFormModel.Pais
        },
        {
            type: Fields.label,
            labelAttr: { text: "frm1_mapa" },
            model: CEscuelaFormModel.Direccion // MAPA
        },
        // *********************
        {
            type: Fields.label,
            labelAttr: { text: "frm1_diasopera" },
            // selectMaterialAttr: { valueMember: "Id", displayMember: "Name", ShowNSelectedInList: true, multiselect: true },
            model: CEscuelaFormModel.DiasOperacion,
            // values: dataDiasOperacion
        },
        {
            type: Fields.input,
            inputAttr: { type: "time" },
            labelAttr: { text: "frm1_hrentrada" },
            model: CEscuelaFormModel.Entrada
        },
        {
            type: Fields.input,
            inputAttr: { type: "time" },
            labelAttr: { text: "frm1_hrsalida" },
            model: CEscuelaFormModel.Salida
        },
        // {
        //     type: ui.controlD3.Fields.selectMaterial,asd
        //     selectMaterialAttr: { valueMember: "Id", displayMember: "Name" },
        //     labelAttr: { text: "Tipo de licencia:" },
        //     values: dataTipoLicencia,
        //     model: CFormModels.TipoLicencia
        // }
    ]
}


function EscuelaForm_OnBuildView(container: TSelectionHTML<"form">, controlsForm: Map<keyof IEscuelaForm, IControlCreated<Fields>>, form: FormGenerator<IEscuelaForm>) {
    // if (this.configModal?.TipoModal == controlD3.CTipoModal.Agregar || this.configModal?.TipoModal == controlD3.CTipoModal.Editar) {
    container
        .classed("escuela_infoedit", true)
        .style("flex-direction", "row")
        .style("gap", "30px")
        .html(`
        <div>
            <div class="row_1">
                <div class="sub_area"><h3>${_L("escuelas.frm1_sectiontag_conf")}</h3> </div>
            </div>
            <div class="row_5">
                <div class="sub_area"><h3>${_L("escuelas.frm1_sectiontag_hor")}</h3> </div>
            </div>
        </div>
        <div>
            <div class="row_2">
                <div class="sub_area"><h3>${_L("escuelas.frm1_sectiontag_hor")}</h3> </div>
            </div>
            <div class="row_4 ${UIUtilGeneral.FBoxOrientation.Vertical}"></div>
        </div>
        `)

    let ObtenerInformacionDeUbicacion = async (lat: number, lng: number) => {
        let res = await _SvEscuelaGoogleGetDirectionInformation((lat + "," + lng), UIUtilLang._GetLanguage());
        if (res.Resultado == -1) {
            // this.notificacion.fn_Mostrar("Ha ocurrido un error al intentar obtener los datos de ubicación", controlD3.Notificacion.CTipoNotificacion.ADVERTENCIA);
            return null;
        }
        return res.Data.results;
    }

    const UpdateControlsLocation = async (geocoder_place_result: google.maps.GeocoderResult | google.maps.places.PlaceResult, lat: number, lng: number, control: IControlCreated<Fields>) => {
        // console.log(geocoderResult, "geocoderResult");
        let latlng = (lat + "," + lng);

        if (geocoder_place_result?.address_components?.length > 0) {
            form._DataOrigin.LatLong = latlng;
            form._DataOrigin.IsChangedLatLong = true;
            // (form["_DatoEscuela"] as IDataEscuela).Direccion = latlng;

            const AsignaValores = (type: string, keyDato: keyof IEscuelaForm) => {
                let componet = geocoder_place_result.address_components.find(d => d.types.indexOf(type) > -1);
                if (componet) {
                    controlsForm.get(keyDato)?.selection?.property("value", componet.long_name);
                    if (keyDato == CEscuelaFormModel.Pais) form._DataOrigin.CodigoPais = componet.short_name;
                } else {
                    controlsForm.get(keyDato)?.selection?.property("value", "");
                    if (keyDato == CEscuelaFormModel.Pais) form._DataOrigin.CodigoPais = "";
                }
            }

            AsignaValores("", CEscuelaFormModel.NumeroInterior);
            AsignaValores("street_number", CEscuelaFormModel.NumeroExterior);
            AsignaValores("route" /* street_address */, CEscuelaFormModel.Calle);
            AsignaValores("postal_code", CEscuelaFormModel.CodigoPostal);
            AsignaValores("locality", CEscuelaFormModel.Ciudad);
            AsignaValores("administrative_area_level_1", CEscuelaFormModel.Estado);
            AsignaValores("country", CEscuelaFormModel.Pais);
        }
    }

    const AppendUI = (idLocation: (1 | 2 | 3 | 4 | 5), idModel: (keyof IEscuelaForm), rowVertical = false) => {
        let control = controlsForm.get(idModel);
        // console.log("Control on build", idModel, Boolean(control));

        if (control) {
            container.select(".row_" + idLocation)
                .append(() => control.row.node());

            control.row
                .style("flex-direction", (rowVertical ? "column" : null), "important")
                .style("row-gap", (rowVertical ? "10px" : null))

            if (idModel == CEscuelaFormModel.Direccion) {
                control.row
                    .classed("map_row", true)
                    .classed(UIUtilGeneral.FBoxOrientation.Horizontal, true)
                    .style("align-items", "flex-start")
                    .style("row-gap", "15px")
                    .style("flex-wrap", "wrap")
                    .style("flex-direction", "column")
                    .style("border-radius", "5px");

                const mapDiv = control.row.append("div")
                    .attr("id", "map")
                    .style("width", "100%")
                    .style("height", "200px");

                const inputSearch = control.row.append("div")
                    .classed("search_wrapper input_content", true)
                    .style("width", "60%")
                    .append("input")
                    .attr("type", "text")
                    .attr("placeholder", UIUtilLang._GetUIString("general", "buscar"))
                    .classed("input-form", true);

                const myLatlng = new google.maps.LatLng(21.1437, -98.4181);

                const mapOptions = <google.maps.MapOptions>{
                    zoom: 6,
                    center: myLatlng,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    fullscreenControl: false,
                    streetViewControl: false,
                    mapTypeControl: false
                };

                const map = new google.maps.Map(mapDiv.node(), mapOptions);

                const markerLocation = new google.maps.Marker({
                    position: null,
                    map: map,
                    title: "School location"
                });

                const searchBox = new google.maps.places.SearchBox(inputSearch.node());
                // map.controls[google.maps.ControlPosition.TOP_LEFT].push(inputSearch); // FIXME

                // Bias the SearchBox results towards current map's viewport.
                map.addListener("bounds_changed", () => {
                    searchBox.setBounds(map.getBounds() as google.maps.LatLngBounds);
                    // console.log("google maps - Bounds changed...", map.getBounds());
                });

                let markersSearchResult: google.maps.Marker[] = [];
                searchBox.addListener("places_changed", () => {
                    const places = searchBox.getPlaces();

                    if (places.length == 0) {
                        return;
                    }

                    // Clear out the old markers.
                    markersSearchResult.forEach((marker) => {
                        marker.setMap(null);
                    });
                    markersSearchResult = [];

                    // Apply selected place data to school data form
                    const isAPlaceSelected = (places.length == 1);
                    if (isAPlaceSelected) {
                        let latlong = places[0].geometry.location;
                        map.setCenter(latlong);
                        map.setZoom(18);
                        markerLocation.setPosition(latlong);
                        UpdateControlsLocation(places[0], latlong.lat(), latlong.lng(), control);
                        return;
                    }

                    // For each place, get the icon, name and location.
                    const bounds = new google.maps.LatLngBounds();
                    places.forEach((place) => {
                        if (!place.geometry || !place.geometry.location) {
                            console.log("Returned place contains no geometry");
                            return;
                        }

                        if (!isAPlaceSelected) {
                            const icon = {
                                url: place.icon as string,
                                size: new google.maps.Size(71, 71),
                                origin: new google.maps.Point(0, 0),
                                anchor: new google.maps.Point(17, 34),
                                scaledSize: new google.maps.Size(25, 25),
                            };

                            // Create a marker for each place.
                            markersSearchResult.push(
                                new google.maps.Marker({
                                    map,
                                    icon,
                                    title: place.name,
                                    position: place.geometry.location,
                                })
                            );
                        }

                        if (place.geometry.viewport) {
                            // Only geocodes have viewport.
                            bounds.union(place.geometry.viewport);
                        } else {
                            bounds.extend(place.geometry.location);
                        }
                    });
                    map.fitBounds(bounds);
                });

                map.addListener("click", (e: google.maps.MapMouseEvent) => {
                    console.log(e, e.latLng.lat(), e.latLng.lng());
                    markerLocation.setPosition(e.latLng);

                    ObtenerInformacionDeUbicacion(e.latLng.lat(), e.latLng.lng())
                        .then(infoLocation => {
                            if (infoLocation?.length > 0) {
                                UpdateControlsLocation(infoLocation[0], e.latLng.lat(), e.latLng.lng(), control);
                            } else if (form._DataOrigin?.LatLong) { // ((<IDataEscuela>form["_DatoEscuela"])?.LatLong) {
                                let latlongTemp = form._DataOrigin?.LatLong.split(","); // (<IDataEscuela>form["_DatoEscuela"])?.LatLong?.split(",");
                                if (latlongTemp?.length == 2) {
                                    markerLocation.setPosition(new google.maps.LatLng(Number(latlongTemp[0]), Number(latlongTemp[1])));
                                }
                            }
                        });
                });

                // if (navigator.geolocation) { // NOTE ¿Descomentar?
                //     console.log("control escuela en AGREGAR");
                //     navigator.geolocation.getCurrentPosition((position) => {
                //         let initialLocation = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                //         map.setCenter(initialLocation);
                //         marker.setPosition(initialLocation);

                //         ObtenerInformacionDeUbicacion(position.coords.latitude, position.coords.latitude)
                //             .then(infoLocation => {
                //                 if (infoLocation) {
                //                     UpdateControlsLocation(infoLocation, position.coords.latitude, position.coords.latitude);
                //                 }
                //             })
                //     });
                // }

                control.instance = map as any; // google.maps.Map
                control["_marker"] = markerLocation;
                control.selection = mapDiv;
            }
            if (idModel == CEscuelaFormModel.DiasOperacion) {
                let contDays = control.row
                    .style("align-items", "flex-start")
                    .append("div")
                    .classed("cont_days", true)
                    .classed(UIUtilGeneral.FBoxOrientation.Vertical, true);

                const UpdateChecked = (dataChecked: number[]) => {
                    let dataItems = UIUtilViewData._GetAllWeekDays()
                        .map(d => ({
                            Check: (dataChecked.find(dC => (dC == d.Id)) !== undefined),
                            Id: d.Id,
                            Name: d.Name
                        }))
                    type TItemDay = typeof dataItems[0];

                    const UpdateItemDay = (item: TSelectionHTML<"div", TItemDay>) => {
                        // Update Label
                        item.select("label").text(d => d.Name);
                        // Update CheckBox
                        let checkbox = item.select(".checkbox_table").each((d, i, arrCheck) => {
                            CheckBox._UpdateCheckStatus(select(arrCheck[i]) as any, d.Check);
                        })
                        // Update Item click event
                        item.on("click", (d, i, arrElems) => {
                            d.Check = !d.Check;

                            CheckBox._UpdateCheckStatus(select(checkbox.nodes()[i]) as any, d.Check);

                            form._DataOrigin.DiasOperacion = dataItems
                                .filter(dItem => dItem.Check)
                                .map(dItem => dItem.Id);
                        })
                    }

                    contDays.selectAll<HTMLDivElement, TItemDay>(".item_day")
                        .data(dataItems)
                        .join(
                            enter => {
                                let itemDay = enter.append("div")
                                    .classed("item_day", true)
                                    .classed(UIUtilGeneral.FBoxOrientation.Horizontal, true)
                                    .classed(UIUtilGeneral.FBoxAlign.StartCenter, true);

                                // itemDay.append<HTMLInputElement>("input").attr("type", "checkbox");
                                itemDay.append(() => CheckBox._GetCheckElement().node());

                                itemDay.append("label");

                                UpdateItemDay(itemDay);
                                return itemDay;
                            },
                            update => {
                                UpdateItemDay(update);
                                return update;
                            },
                            exit => exit.remove()
                        )
                }

                UpdateChecked([]);
                control["_AssingData"] = UpdateChecked;
                control.selection = contDays;
            }
        }
    }
    AppendUI(1, CEscuelaFormModel.Logo);
    AppendUI(1, CEscuelaFormModel.Nombre);
    AppendUI(1, CEscuelaFormModel.Tamanio);
    AppendUI(1, CEscuelaFormModel.Telefono);
    AppendUI(1, CEscuelaFormModel.Correo);
    // AppendUI(1, CFormModels.TipoLicencia);

    AppendUI(2, CEscuelaFormModel.Direccion);

    AppendUI(4, CEscuelaFormModel.Calle);
    AppendUI(4, CEscuelaFormModel.NumeroExterior);
    AppendUI(4, CEscuelaFormModel.NumeroInterior);
    AppendUI(4, CEscuelaFormModel.CodigoPostal);
    AppendUI(4, CEscuelaFormModel.Ciudad);
    AppendUI(4, CEscuelaFormModel.Estado);
    AppendUI(4, CEscuelaFormModel.Pais);

    AppendUI(5, CEscuelaFormModel.DiasOperacion); // DiasOperacion
    // appendUI("row_6", CFormModels.HorarioInicial);
    AppendUI(5, CEscuelaFormModel.Entrada);
    AppendUI(5, CEscuelaFormModel.Salida);
    // }
}

// FORMULARIO DE ESCUELA


export function _EscuelaForm_GetForm(action: (CAccionPermiso.Agregar | CAccionPermiso.Editar), datoE = <IEscuela>{}) {
    let dataForm: IEscuelaForm = Object.assign({}, datoE);
    let form = new FormGenerator<IEscuelaForm>();
    let esEditar = (action == CAccionPermiso.Editar);

    // >> Flags Logo and LatLong change
    dataForm.IsChangedLogo = false;
    dataForm.IsChangedLatLong = false;

    if (esEditar) {
        // >> PREPARACIÓN DE DATOS

        // >> Secciona la dirección
        let splitDirection = (dataForm?.Direccion ? dataForm.Direccion : "").split("\n");

        if (splitDirection.length == 8) {
            dataForm.NumInterior = splitDirection[0];
            dataForm.Calle = splitDirection[1];
            dataForm.NumExterior = splitDirection[2];
            dataForm.CodigoPostal = splitDirection[3];
            dataForm.Ciudad = splitDirection[4];
            dataForm.Estado = splitDirection[5];
            dataForm.Pais = splitDirection[6];
            dataForm.LatLong = splitDirection[7];
        }

        // >> Preparación de días de operación
        dataForm.DiasOperacion = [];
        dataForm.HoraEntradas?.forEach((hr, i) => {
            if (hr) {
                dataForm.DiasOperacion.push(i + 1);
                dataForm.Entrada = hr.slice(0, 5);
                dataForm.Salida = dataForm.HoraSalidas[i].slice(0, 5);
            }
        });
    }

    form._Crear({
        LangModuleKeyInContext: "escuelas", // REMOVER
        schema: EscuelaForm_GetSchema(form),
        BuildView: (container, controlsForm, form) => EscuelaForm_OnBuildView(container, controlsForm as any, form),
        Validation: (value, field, allObject, controls) => {
            const getIsValido = (val) => (Boolean(val) && Boolean(String(val).trim()));

            if (field == CEscuelaFormModel.Direccion) {
                // NOTE Validacion: La zona horaria no puede editarse cuando `esEditar`
                // FIXME Temporalmete se valida en el modal de Editar
                return getIsValido(form._DataOrigin.LatLong);
            }
            else if (field == CEscuelaFormModel.DiasOperacion) {
                const diasOperaEsc = form._DataOrigin[CEscuelaFormModel.DiasOperacion];
                if (getIsValido(diasOperaEsc) && diasOperaEsc.length) {
                    if (dataForm.IdKinder) {
                        const grupos = _LOCALDATA_GetGruposEnEscuela(dataForm.IdKinder);

                        for (const [_, grupo] of grupos) {
                            for (const grupoDia of grupo.Horario) {
                                if (!diasOperaEsc.find(dia => (grupoDia.IdDia == dia))) {
                                    NotificacionV2._Mostrar(
                                        _L("escuelas.notif_err_horariodia")
                                            .replace("_DIA", UIUtilTime._GetDayName(grupoDia.IdDia).toLowerCase())
                                            .replace("_GRUPO", UIUtilViewGrupos._GetLblGrupoName(grupo)),
                                        "ADVERTENCIA"
                                    );
                                    // console.warn(grupo, grupoDia, diasOperaEsc);
                                    return false;
                                }
                            }
                        }

                        return true;
                    }
                    return true;
                }
                return false;
            }
            // else if (field == CFormModels.Correo) {
            // return Utils.emailRegex.test(value);
            // }
            else if (field == CEscuelaFormModel.Entrada || field == CEscuelaFormModel.Salida) {
                // >> Valida que la hora de salida sea mayor que la de entrada
                if (!getIsValido(value)) {
                    return _L("control.form.required");
                }
                const inputHrEntrada = (controls.get(CEscuelaFormModel.Entrada).selection as TSelectionHTML<"input">).node();
                const inputHrSalida = (controls.get(CEscuelaFormModel.Salida).selection as TSelectionHTML<"input">).node();

                if (inputHrSalida.valueAsNumber > inputHrEntrada.valueAsNumber) {
                    if (dataForm.IdKinder) {
                        const timeZone = form._Data.ZonaHoraria;
                        const diasOperaEsc = form._DataOrigin.DiasOperacion;
                        const grupos = _LOCALDATA_GetGruposEnEscuela(dataForm.IdKinder);
                        for (const [_, grupo] of grupos) {
                            for (const grupoDia of grupo.Horario) {
                                if (diasOperaEsc.find(dia => (dia == grupoDia.IdDia))) {
                                    let dtEntradaGrupo = new DateV2(grupoDia.Entrada)._SetTimeZone(timeZone);
                                    let dtSalidaGrupo = new DateV2(grupoDia.Salida)._SetTimeZone(timeZone);
                                    let dtDiaEscHrEntrada = new DateV2(dtEntradaGrupo)
                                    dtDiaEscHrEntrada.setHours(0, 0, 0, 0);
                                    dtDiaEscHrEntrada._SetLocalStrHour(inputHrEntrada.value);
                                    let dtDiaEscHrSalida = new DateV2(dtSalidaGrupo)
                                    dtDiaEscHrSalida.setHours(0, 0, 0, 0);
                                    dtDiaEscHrSalida._SetLocalStrHour(inputHrSalida.value);

                                    if ((field == CEscuelaFormModel.Entrada) && (dtDiaEscHrEntrada > dtEntradaGrupo)) {
                                        NotificacionV2._Mostrar(
                                            _L("escuelas.notif_err_hrentrada")
                                                .replace("_DIA", UIUtilTime._GetDayName(grupoDia.IdDia).toLowerCase())
                                                .replace("_GRUPO", UIUtilViewGrupos._GetLblGrupoName(grupo)),
                                            "ADVERTENCIA"
                                        );
                                        return false;
                                    }
                                    else if ((field == CEscuelaFormModel.Salida) && (dtDiaEscHrSalida < dtSalidaGrupo)) {
                                        NotificacionV2._Mostrar(
                                            _L("escuelas.notif_err_hrsalida")
                                                .replace("_DIA", UIUtilTime._GetDayName(grupoDia.IdDia).toLowerCase())
                                                .replace("_GRUPO", UIUtilViewGrupos._GetLblGrupoName(grupo)),
                                            "ADVERTENCIA"
                                        );
                                        return false;
                                    }
                                }
                            }
                        }
                    }
                    return true;
                } else {
                    let mensaje = _L("escuelas.notif_err_horario");
                    if (field == "Entrada") {
                        NotificacionV2._Mostrar(mensaje, "ADVERTENCIA");
                    }
                    // NotificacionV2.fn_Mostrar("La hora de salida debe ser mayor a la hora de entrada", controlD3.Notificacion.CTipoNotificacion.ADVERTENCIA);
                    return false;
                }
            }
            else if (controls.get(field).type == Fields.input) {
                // console.log(field, value)
                let input = controls.get(field).selection.node() as HTMLInputElement;
                if (input.validity.valid) {
                    if (field == CEscuelaFormModel.NumeroInterior || field == CEscuelaFormModel.NumeroExterior || field == CEscuelaFormModel.CodigoPostal) {
                        return !isNaN(Number(value));
                    }
                    return true;
                }
                return false;
            } else {
                return getIsValido(value);
            }
        }
    }, dataForm);

    if (esEditar) {
        // >> Ajuste de controles a los que el formulario no tiene acceso directo

        let latLngSplit = dataForm.LatLong?.split(",");
        if (latLngSplit?.length == 2) {
            let control = form._ControlsData.get(CEscuelaFormModel.Direccion);
            let map = (control.instance as any) as google.maps.Map;
            let marker = (control["_marker"] as google.maps.Marker);

            let initialLocation = new google.maps.LatLng(Number(latLngSplit[0]), Number(latLngSplit[1]));
            map.setCenter(initialLocation);
            map.setZoom(15);
            marker.setPosition(initialLocation);
            marker.setTitle(dataForm.Nombre);
        }

        let controlDias = form._ControlsData.get(CEscuelaFormModel.DiasOperacion);
        controlDias["_AssingData"](dataForm.DiasOperacion);
    }

    return form;
}